import { render, staticRenderFns } from "./filtered_list.vue?vue&type=template&id=8d442800&"
import script from "./filtered_list.vue?vue&type=script&lang=js&"
export * from "./filtered_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports